import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import ReactToggle from "react-toggle"
import "react-toggle/style.css"
import * as Yup from "yup"
import { Col, Row } from "reactstrap"
import { Fn_DisplayData, Fn_FillListData, Fn_AddEditData } from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useLocation, useNavigate } from "react-router-dom"

function AddEdit_CustomerMaster() {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/Sales`
  const API_URL2 = `${API_WEB_URLS.MASTER}/0/token/State`
  const API_URL_SAVE = "CustomerMaster/0/token"
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/CustomerMasterEdit/Id`

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    FillArray2: [],
    formData: {},
    isProgress: true,
  })

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", `${API_URL}/Id/0`)
    Fn_FillListData(dispatch, setState, "FillArray2", `${API_URL2}/Id/0`)

    const Id = (location.state && location.state.Id) || 0
    if (Id > 0) {
      setState(prevState => ({ ...prevState, id: Id }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  const validationSchema = Yup.object({
    F_SalesMaster: Yup.string().required("Sales Person is required"),
    Name: Yup.string().required("Name is required"),
    Address: Yup.string().required("Address is required"),
    IsActive: Yup.boolean().required("Active status is required"),
    GSTNo: Yup.string(),
    FASSAINo: Yup.string(),
    UDYAM: Yup.string(),
    F_StateMaster: Yup.string(),
    Phone1: Yup.string(),
    Phone2: Yup.string(),
    Password: Yup.string(),
  })

  const handleSubmit = async values => {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    const formData = new FormData()
    formData.append("F_SalesMaster", values.F_SalesMaster)
    formData.append("Name", values.Name)
    formData.append("Address", values.Address)
    formData.append("IsActive", values.IsActive)
    formData.append("UserId", obj.uid)
    formData.append("GSTNo", values.GSTNo)
    formData.append("FASSAINo", values.FASSAINo);
    formData.append("UDYAM", values.UDYAM);
    formData.append("F_StateMaster", values.F_StateMaster)
    formData.append("Password", values.Password)
    formData.append("Phone1", values.Phone1)
    formData.append("Phone2", values.Phone2)
    formData.append("UserId", obj.uid)

    Fn_AddEditData(dispatch, setState, { arguList: { id: state.id, formData } }, API_URL_SAVE, true, "memberid",
      navigate,
    "/Customermaster")
  }

  return (
    <div className="page-content">
      <Formik
        initialValues={{ ...state.formData, IsActive: state.formData.IsActive || false }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg="2"><label htmlFor="F_SalesMaster" className="form-label">Sales Person</label></Col>
              <Col lg="6" className="mb-3">
                <Field as="select" name="F_SalesMaster" className="form-control">
                  <option value="">Select SalesMaster</option>
                  {state.FillArray.map(type => (
                    <option key={type.Id} value={type.Id}>{type.Name}</option>
                  ))}
                </Field>
                <ErrorMessage name="F_SalesMaster" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="Name" className="form-label">Customer Name</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="Name" className="form-control" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="Address" className="form-label">Address</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="Address" className="form-control" />
                <ErrorMessage name="Address" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="GSTNo" className="form-label">GST No</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="GSTNo" className="form-control" />
                <ErrorMessage name="GSTNo" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="FASSAINo" className="form-label">FSSAI No</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="FASSAINo" className="form-control" />
                <ErrorMessage name="FASSAINo" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="UDYAM" className="form-label">UDYAM Reg No</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="UDYAM" className="form-control" />
                <ErrorMessage name="UDYAM" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="F_StateMaster" className="form-label">State</label></Col>
              <Col lg="6" className="mb-3">
                <Field as="select" name="F_StateMaster" className="form-control">
                  <option value="">Select State</option>
                  {state.FillArray2.map(type => (
                    <option key={type.Id} value={type.Id}>{type.Name}</option>
                  ))}
                </Field>
                <ErrorMessage name="F_StateMaster" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="Phone1" className="form-label">Phone 1</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="Phone1" className="form-control" />
                <ErrorMessage name="Phone1" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="Password" className="form-label">Password</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="Password" className="form-control" />
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="Phone2" className="form-label">Phone 2</label></Col>
              <Col lg="6" className="mb-3">
                <Field type="text" name="Phone2" className="form-control" />
                <ErrorMessage name="Phone2" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2"><label htmlFor="IsActive" className="form-label">Active</label></Col>
              <Col lg="6" className="mb-3">
                <ReactToggle
                  checked={values.IsActive}
                  onChange={() => setFieldValue("IsActive", !values.IsActive)}
                />
                <ErrorMessage name="IsActive" component="div" className="text-danger" />
              </Col>
            </Row>

            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddEdit_CustomerMaster
